import { OTRSelect } from './OTRSelect';
import { OTRDateField } from './OTRDateField';
import React from 'react';
import { DocumentUploadField } from './DocumentUploadField';

export const ExpenseLineRow = ({ 
  line, 
  expenseHeads, 
  onChange, 
  onRemove, 
  isReadOnly = false,
  errors = {},
  currencySymbol = '₹'
}) => {
  const handleChange = (field, value) => {
    onChange({ ...line, [field]: value });
  };
console.log("expenseHeads:", expenseHeads);
console.log("current line:", line);



  return (
    <div className="p-5 bg-white rounded-2xl border border-[var(--color-border)] shadow-sm mb-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-5">
        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider ml-1">Expense Head</label>
          <OTRSelect
            value={line.expenseHeadId}
            onChange={(v) => handleChange('expenseHeadId', parseInt(v))}
            options={expenseHeads.map(head => ({ value: head.headId, label: head.headName }))}
            placeholder="Select Head"
            disabled={isReadOnly}
            hasError={!!errors.expenseHeadId}
          />
          {errors.expenseHeadId && <span className="text-[10px] text-[var(--color-error)] font-bold ml-1">{errors.expenseHeadId}</span>}
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider ml-1">Date</label>
          <OTRDateField
            value={line.entryDate}
            onChange={(v) => handleChange('entryDate', v)}
            disabled={isReadOnly}
            hasError={!!errors.entryDate}
          />
          {errors.entryDate && <span className="text-[10px] text-[var(--color-error)] font-bold ml-1">{errors.entryDate}</span>}
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider ml-1">Amount</label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-sm font-bold text-[var(--color-text-secondary)]">{currencySymbol}</span>
            <input
              type="number"
              value={line.amount || ''}
              onChange={(e) => handleChange('amount', parseFloat(e.target.value) || 0)}
              disabled={isReadOnly}
              placeholder="0.00"
              className={`w-full h-11 pl-8 pr-4 text-sm font-bold rounded-xl border-[var(--color-text-border)] bg-white outline-none transition-all ${
                errors.amount ? 'border-[var(--color-error)]' : 'focus:ring-2 focus:ring-[var(--color-primary)]/20'
              }`}
            />
          </div>
          {errors.amount && <span className="text-[10px] text-[var(--color-error)] font-bold ml-1">{errors.amount}</span>}
        </div>

        <div className="flex flex-col gap-1.5">
          <label className="text-[10px] font-bold text-[var(--color-text-secondary)] uppercase tracking-wider ml-1">Proof / Receipt</label>
          <DocumentUploadField
            value={line.document}
            onChange={(file) => handleChange('document', file)}
            isReadOnly={isReadOnly}
            error={errors.document}
          />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between pt-4 border-t border-[var(--color-workspace)]">
        <div className="flex-1">
          <input
            type="text"
            value={line.remarks || ''}
            onChange={(e) => handleChange('remarks', e.target.value)}
            disabled={isReadOnly}
            placeholder="Add remarks or justification..."
            className="w-full h-9 px-4 text-[12px] bg-transparent border-none outline-none text-[var(--color-text-secondary)] focus:text-foreground italic"
          />
        </div>
        {!isReadOnly && (
          <button
            onClick={onRemove}
            className="ml-4 text-[var(--color-error)] hover:bg-[var(--color-error)]/10 px-3 py-1.5 rounded-lg text-[11px] font-bold uppercase transition-all"
          >
            Remove
          </button>
        )}
      </div>
    </div>
  );
};
